import { StringKeyDictionary } from "../../commonInterfaces.js";
import { Helper } from "../util/helper.js";
import { HTTPService } from "../util/httpManager.js";
import { InternalTab } from "./applicationTabstrip.js";
import { FAIcon } from "./faIcon.js";
import { FALayerIcon, FALayerIconPart } from "./faLayerIcon.js";
import { AdditionalTabInfo } from "./tabStrip.js";
import React from "react";
class LeftDrawerItem extends React.Component<LeftDrawerItemProps, { additionalInfoString?: string }> {
    private mounted = true;
    constructor(props) {
        super(props);
        this.state = {};
    }

    private getParamValues = (): StringKeyDictionary<string> => {
        const statisticProps = this.props.additionalInfo.props;
        if (!statisticProps) {
            return {};
        }
        const params: StringKeyDictionary<string> = {};
        for (let key in statisticProps) {
            if (typeof statisticProps[key] == "string") {
                params[key] = this.props.handleEval(statisticProps[key]);
            }
            else {
                params[key] = statisticProps[key];
            }
        }
        return params;
    }
    private getData = async () => {
        const params = this.getParamValues();
        const searchParams = new URLSearchParams(params).toString();
        const url = `statistic/api/dynamicapi/${this.props.additionalInfo.apiId}/GetData${(searchParams && searchParams != "") ? "?" + searchParams : ""}`;

        const result = await HTTPService.noBusyIndicator().get(url);
        if (result && result.length > 0) {
            const template = kendo.template(this.props.additionalInfo.template);
            const templateResult: any = template({ row: result[0] });
            this.setState({ additionalInfoString: templateResult }, () => {
                if (this.mounted && this.props.additionalInfo.refreshInterval) {
                    setTimeout(() => {
                        this.getData();
                    }, this.props.additionalInfo.refreshInterval * 1000);
                }
            });

        }
    }

    componentDidMount() {
        if (this.props.additionalInfo) {
            this.getData();
        }
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        const icons: Array<FALayerIconPart> = [];
        if (Array.isArray(this.props.icons)) {
            this.props.icons.forEach(i => {
                icons.push({
                    name: i
                });
            });
        }

        return (
            <div>
                <div className={"tabstrip__item " + (Helper.hasValue(this.props.wrapperClass) ? this.props.wrapperClass : "")} title={this.props.label} onClick={e => Helper.hasValue(this.props.onClick) ? this.props.onClick(this.props.id) : null} id={this.props.id}>
                    <div className={"tabstrip__changes"}>{this.props.hasChanges ? "*" : ""}</div>
                    <span className="tabstrip__item__label-wrapper">
                        {
                            icons.length > 0 ?
                                <FALayerIcon icons={icons} />
                                :
                                (
                                    Helper.hasValue(this.props.icon) ?
                                        <FAIcon name={this.props.icon} sameWidth={true} wrapperClass="tabstrip__item__icon" />
                                        : null
                                )
                        }
                        <label className="tabstrip__item__label truncate">{this.props.label}</label>
                        {this.state.additionalInfoString ?
                            <div className="tabs_additional_info" dangerouslySetInnerHTML={{ __html: this.state.additionalInfoString }}></div>
                            : null
                        }
                    </span>
                    {
                        icons.length > 0 || Helper.hasValue(this.props.icon) ?
                            <span className="tabstrip__item__trailing-icon-wrapper" title={this.props.label}>
                                {
                                    icons.length > 0 ?
                                        <FALayerIcon icons={icons} />
                                        :
                                        <FAIcon name={this.props.icon} sameWidth={true} wrapperClass="tabstrip__item__icon tabstrip__item__icon--trailing" />
                                }
                            </span>
                            :
                            null
                    }

                </div>

            </div>
        );
    }
}

export function LeftDrawerMenuItem({ tabs, getTabItem, onClick }) {
    const menuRef = React.useRef<kendo.ui.ContextMenu>(null);

    React.useEffect(() => {
        menuRef.current = $("#tabstripMenuList").kendoContextMenu({
            target: "#tabstripMenuTrigger",
            closeOnClick: true,
            select: (e) => {
                let index = $(e.item).index();
                onClick(tabs[index]);
            }
        }).data("kendoContextMenu");

        return () => {
            if (menuRef.current)
                menuRef.current.destroy();
        }
    }, []);

    return <>
        <div id="tabstripMenuTrigger" onClick={(e) => { menuRef.current.open(e.currentTarget) }}>
            <LeftDrawerItem label={Helper.getTranslation("WebSMS.GeneralSettings.Units.ShowMore")}
                icon={"caret-down"}
                id="tabstripLeftDrawerItem" />
        </div>

        <ul id="tabstripMenuList"> {
            tabs.map((tab, index) => (
                <li key={index}>
                    <span>
                        {getTabItem(tab)}
                    </span>
                </li>
            ))}
        </ul>
    </>
}

export { LeftDrawerItem as LeftDrawerItem };


export interface LeftDrawerItemProps {
    label: string;
    id: string;
    icon?: string;
    icons?: Array<string>;
    onClick?: (id: string) => void;
    wrapperClass?: string;
    hasChanges?: boolean;
    additionalInfo?: AdditionalTabInfo;
    handleEval?;
}